import React, { useEffect } from 'react';
import classNames from 'classnames';
import { useAccordionContext } from './AccordionContext';

export interface AccordionContentProps {
  as?: React.ElementType;
  children?: React.ReactNode;
  className?: string;
  id: string;
  variant?: 'default' | 'unstyled';
  onOpen?: () => void;
}

const AccordionContent = ({
  as: Component = 'div',
  children,
  className,
  id,
  variant = 'default',
  onOpen,
}: AccordionContentProps): JSX.Element => {
  const { isOpen } = useAccordionContext();
  const expanded = isOpen(id);

  useEffect(() => {
    if (expanded && onOpen) {
      onOpen();
    }
  }, [expanded, onOpen]);

  return (
    <Component
      id={id}
      className={classNames(className, {
        'usa-accordion__content': variant === 'default',
      })}
      hidden={!expanded}
    >
      {children}
    </Component>
  );
};

export default AccordionContent;
